@if (show) {
  <a class="text-decoration-none" [class]="params.className" (click)="onClick()">
    <i class="fa-lg" [class]="iconClass"></i>
    @if (params.buttonText) {
      <span class="fw-bold">&nbsp;{{ params.buttonText }}</span>
    }
  </a>
}
